module.exports = __webpack_public_path__ + "static/chromagen logo-44df1d007e6b4e5a6d85a4301003f039.png";